import { render, staticRenderFns } from "./FeesConfig.vue?vue&type=template&id=b3828c18"
import script from "./FeesConfig.vue?vue&type=script&lang=js"
export * from "./FeesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports